import { createAsyncThunk } from '@reduxjs/toolkit';
import firebase from 'firebase/app';
import { INVITE_ALL_USERS } from '../../constants/post';

const COLLECTION_NAME = 'posts';

const getCollection = () => firebase.firestore().collection(COLLECTION_NAME);

export const fetchPendingPosts = createAsyncThunk(
    'fetchPendingPosts',
    async ({ email, activeCategory = null }, { rejectWithValue }) => {
        try {
            const initialQuery = () => {
                if (!email) {
                    return null;
                }
                let query = getCollection();

                if (activeCategory) {
                    query = query.where('category', '==', activeCategory);
                }

                return query
                    .where('inviteColleagues', 'array-contains', INVITE_ALL_USERS)
                    .where('isDeleted', '==', false);
            };

            if (!initialQuery()) {
                return;
            }

            let result = new Map();

            await initialQuery()
                .orderBy('createdTimestamp', 'desc')
                .get()
                .then(data => {
                    data.docs.map((doc, index) => result.set(index, doc.data()));
                });

            return {
                pending: [...result.values()].filter(item => !item.isReviewedByAdmin).slice(0, 15),
                approved: [...result.values()]
                    .filter(item => item?.approvedByAdminDate)
                    .slice(0, 15),
                rejected: [...result.values()]
                    .filter(item => item?.rejectedByAdminDate)
                    .slice(0, 15),
            };
        } catch (e) {
            return rejectWithValue(e.message);
        }
    }
);
